import * as React from "react";

function SvgEmail(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 28" fill="none" {...props}>
      <path
        d="M30.6 0H3.4C1.53 0 .017 1.53.017 3.4L0 24.418c0 1.87 1.53 3.4 3.4 3.4h27.2c1.87 0 3.4-1.53 3.4-3.4V3.4C34 1.53 32.47 0 30.6 0zm-.68 7.225l-12.019 7.514a1.72 1.72 0 01-1.802 0L4.08 7.225a1.455 1.455 0 01-.68-1.224c0-1.139 1.241-1.819 2.21-1.224L17 11.9l11.39-7.123c.969-.595 2.21.085 2.21 1.224 0 .493-.255.952-.68 1.224z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgEmail;
